import React from 'react';
import { NavigationItem } from './NavigationItem';
import { ExternalUrlFactory } from '../../rest/ExternalUrlFactory';

export const SpruceHelpInlineLink = () => (
  <NavigationItem
    text={`click here`}
    href={ExternalUrlFactory().urlFor.spruceHelpLinkUrl()}
    isInline
    target={`_blank`}
  />
);
